jQuery(function ($) {
    let product_ids = [];
    let product_limit = 5;
    let $boxIdInput = $('#box-id');
    let $bundleTopLevelProductInput = $('#top-level-bundle');
    let $product_ids_input = $('#product-ids');
    let $menuSelector = $('.js-bab-menu-selector');
    let $veganCheckbox = $('#vegan-filter');
    let $nextPageBtn = $('.js-next-page-btn');
    let $productModal = $('#bab-product-modal');
    let $giftBoxInput = $('#gift-box-id');
    let $giftInput = $('#gift-ids');
    let $packagingInput = $('#packaging-id');
    let $cardInput = $('#card-id');
    let $disableMessageCheckbox = $('#disable-checkout-message');
    let $cardMessageInput = $('#card-message');

    let sliceProductSlice3 = $('#slice-product-3');
    let sliceProductSlice5 = $('#slice-product-5');

    let $5sliceBoxProducts = $('#boxes-5-slice');
    let $3sliceBoxProducts = $('#boxes-3-slice');

    let gift_ids = [];
    let packaging_ids = [];
    let card_ids = [];

    let $page1 = $('#page-1');
    let $page2 = $('#page-2');
    let $page3 = $('#page-3');

    // Custom Quantity Control
    $(document).on('click', '.js-quantity-control-minus', function (e) {
        e.preventDefault();
        let target = $(this).siblings('input');
        let stepSize = parseInt($(target).attr('step'));
        let min = $(target).attr('min');
        let currVal = parseInt($(target).val());
        let newVal = currVal - stepSize;
        let type = $(target).data('type');

        if (newVal >= min) {
            $(target).val(newVal);

            if (type == 'slice') {
                remove_product($(target).data('id'));
            } else if (type == 'gift') {
                remove_gift($(target).data('id'));
            } else if (type == 'packaging') {
                remove_packaging();
            } else if (type == 'card') {
                remove_card();
            }
        }
    });

    $(document).on('click', '.js-quantity-control-plus', function (e) {
        e.preventDefault();
        let target = $(this).siblings('input');
        let stepSize = parseInt($(target).attr('step'));
        let max = $(target).attr('max');
        let currVal = parseInt($(target).val());
        let newVal = currVal + stepSize;
        let type = $(target).data('type');

        if (newVal <= max) {
            $(target).val(newVal);

            if (type == 'slice') {
                add_product($(target).data('id'));
            } else if (type == 'gift') {
                add_gift($(target).data('id'));
            } else if (type == 'packaging') {
                add_packaging($(target).data('id'));
            } else if (type == 'card') {
                add_card($(target).data('id'));
            }
        }
    });

    // Collapse
    $('.js-bab-collapse').click(function (e) {
        e.preventDefault();
        let target = $(this).data('target');
        $(target).slideToggle();

        let relatedTab = $('.js-extra-tab-trigger[data-related-dropdown="' + target + '"]');
        $(relatedTab).click();
    });

    // Tabs
    $('.js-bab-tab').click(function (e) {
        e.preventDefault();

        let target = $(this).data('target');

        let toClose = $(target).siblings('.js-box-switcher-tab');
        toClose.hide();
        toClose.removeClass('active');
        $(target).show();
        $(target).addClass('active');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        // Update box id
        $boxIdInput.val($(this).data('product-id'));
        $boxIdInput.data('price', $(this).data('price'));

        // Update Limit
        product_limit = $(this).data('limit');
        $('.js-limit-counter').text(product_limit);

        // Empty out additional selected products
        //remove_all_products();
        remove_extra_products(product_limit);

        // Update prices
        update_prices();

        // Update box products
        if (product_limit == 3) {
            $3sliceBoxProducts.show();
            $5sliceBoxProducts.hide();

            let $boxDetails = $('#primary-box-3-slice');
            $giftBoxInput.val($boxDetails.val());
            $giftBoxInput.data('price', $boxDetails.data('price'));
            $giftBoxInput.data('product-id', $boxDetails.data('product-id'));
            $giftBoxInput.data('product-title', $boxDetails.data('product-title'));
            $giftBoxInput.data('variant-title', $boxDetails.data('variant-title'));



            updateBoxPreview($boxDetails.val());
        } else {
            $5sliceBoxProducts.show();
            $3sliceBoxProducts.hide();

            let $boxDetails = $('#primary-box-5-slice');
            $giftBoxInput.val($boxDetails.val());
            $giftBoxInput.data('price', $boxDetails.data('price'));
            $giftBoxInput.data('product-id', $boxDetails.data('product-id'));
            $giftBoxInput.data('product-title', $boxDetails.data('product-title'));
            $giftBoxInput.data('variant-title', $boxDetails.data('variant-title'));
            updateBoxPreview($boxDetails.val());
        }
    });

    $('.js-bab-tab-change-btn').click(function (e) {
        e.preventDefault();
        $('#5-slice-btn').click();
    });

    // Product Modal
    $('.js-bab-product-modal-close').click(function (e) {
        e.preventDefault();
        $productModal.removeClass('show');
    });

    $(document).on('click', '.js-bab-product-modal-trigger', function (e) {
        e.preventDefault();

        let prod = $(this).data('product-id');
        let type = $(this).data('product-type');
        let product_data = null;

        if (type == 'box') {
            jQuery.each(box_products, function (index, item) {
                if (item.id === prod) {
                    product_data = item;
                    return false; // Break array
                }
            });
        } else if (type == 'gift') {
            jQuery.each(gift_products, function (index, item) {
                if (item.id === prod) {
                    product_data = item;
                    return false; // Break array
                }
            });
        } else if (type == 'packaging') {
            jQuery.each(packaging_products, function (index, item) {
                if (item.id === prod) {
                    product_data = item;
                    return false; // Break array
                }
            });
        } else if (type == 'card') {
            jQuery.each(card_products, function (index, item) {
                if (item.id === prod) {
                    product_data = item;
                    return false; // Break array
                }
            });
        } else {
            jQuery.each(collection_products, function (index, item) {
                if (item.id === prod) {
                    product_data = item;
                    return false; // Break array
                }
            });
        }

        if (product_data != null) {
            let title = $("<div/>").html(product_data.title).text();
            $('.js-product-modal-title').html(title);

            $('.js-product-modal-price').text(product_data.price_formatted);

            let description = $("<div/>").html(product_data.description).text();
            $('.js-product-modal-description').html(description);

            if (product_data.ingredients != '' && product_data.ingredients != null) {
                let ingredients = $("<div/>").html(product_data.ingredients).text();
                $('.js-product-modal-ingredients-content').html(ingredients);

                $('.js-product-modal-ingredients').show();
            } else {
                $('.js-product-modal-ingredients').hide();
            }

            let modalQuantityInput = $productModal.find('input[name="quantity"]');

            modalQuantityInput.attr('data-id', parseInt(product_data.id));
            modalQuantityInput.prop('data-id', parseInt(product_data.id));

            if (product_data.images.length > 0) {
                $('.js-product-modal-main-image').html('<img src="' + product_data.images[0] + '"/>');

                let thumbnail_html = '';

                jQuery.each(product_data.images, function (index, item) {
                    thumbnail_html += '<div class="bab-product-modal__modal__body__images__thumbnails__thumbnail"><img src="' + item + '" class="js-product-modal-thumbnail"/></div>';
                });

                $('.js-product-modal-thumbnails').html(thumbnail_html);
            }

            $productModal.addClass('show');


        }
    });

    $(document).on('click', '.js-product-modal-thumbnail', function (e) {
        e.preventDefault();

        let img_url = $(this).attr('src');
        $('.js-product-modal-main-image').html('<img src="' + img_url + '"/>');
    });

    // Mobile Tray
    $('.js-bab-tray-toggle').click(function (e) {
        e.preventDefault();

        let activeClass = 'open';
        let target = $(this).data('target');

        let maxHeight = $(window).height() - 160;

        if ($(this).hasClass(activeClass)) {
            // Close
            $(target).slideUp();
            $(this).removeClass(activeClass);
            $('body').removeClass('no-scroll');
        } else {
            // Open
            $(target).slideDown();
            $(target).css('max-height', maxHeight);
            $(this).addClass(activeClass);
            $('body').addClass('no-scroll');
        }
    });

    // Menu Switch
    $menuSelector.change(function () {
        let val = $(this).val();

        // Show/hide products
        $('.js-menu-group').hide();
        $(val).show();

        // Dispatch dates
        let deliveryDateVal = $(this).find(":selected").data('ship-date');
        let $deliveryDateWrapper = $('.js-delivery-date-wrapper');
        let $deliveryDate = $('.js-delivery-date');

        if (deliveryDateVal == "" || deliveryDateVal == null) {
            $deliveryDateWrapper.hide();
        } else {
            $deliveryDate.text(deliveryDateVal);
            $deliveryDateWrapper.show();
        }

        // Clear all selections
        remove_all_products();
    });

    // Vegan Switch
    $veganCheckbox.change(function (e) {
        let $standProducts = $('.js-standard-products');
        let $veganProducts = $('.js-vegan-products');

        if ($(this).is(':checked')) {
            $standProducts.hide();
            $veganProducts.show();
        } else {
            $standProducts.show();
            $veganProducts.hide();
        }
    });

    // PreFilled Product Options
    $(document).on('click', '.js-bab-fill-btn', function (e) {
        e.preventDefault();

        let selectedMenu = $menuSelector.val();

        let products = $(selectedMenu + ' #fill-products').val();

        if ($veganCheckbox.is(':checked')) {
            products = $(selectedMenu + ' #fill-products-vegan').val();
        }

        let preFillIds = products.split(",");
        if (preFillIds.length > 0) {
            // Clear out current products first
            remove_all_products();

            let idsToAdd = preFillIds;

            // If there's not enough fill products to fill the box then
            // just duplicate the prefill until there is
            while (idsToAdd.length < product_limit) {
                idsToAdd = jQuery.merge(idsToAdd, idsToAdd);
            }

            if(idsToAdd.length > product_limit) {
                idsToAdd.length = product_limit;
            }

            jQuery.each(idsToAdd, function (index, item) {
                add_product(parseInt(item));
            });
        }
    });

    // Next Page Btn
    $nextPageBtn.click(function (e) {
        e.preventDefault();

        if (!$(this).is(":disabled")) {
            let nextPage = $(this).data('next-page');

            if (nextPage >= 4) {
                add_box_to_cart();
                $('#bab-success-modal').show();
            } else {
                goToPage(nextPage);
            }
        }

        $(this).blur();
    });

    // Progress Bar Page Links
    $('.js-progress-bar-item button').click(function (e) {
        e.preventDefault();

        if (!$(this).is(":disabled")) {
            goToPage($(this).data('page'));
        }
    });

    // Add Box Product Type
    $(document).on('click', '.js-bab-add-box', function (e) {
        e.preventDefault();

        let $currActiveBtn = $('.js-bab-add-box.active'),
            box_product_id = $(this).data('product-id'),
            box_price = parseFloat($(this).data('price'));
        

        unsetActiveBtn($currActiveBtn);
        setActiveBtn($(this));
        $giftBoxInput.val(box_product_id);
        $giftBoxInput.data('price',box_price)
        $giftBoxInput.data('product-id',$(this).data('product-id'))
        $giftBoxInput.data('product-title',$(this).data('product-title'))
        $giftBoxInput.data('variant-title',$(this).data('variant-title'))

        updateBoxPreview(box_product_id);
        update_prices();
        triggerToggleAnimation();
    });

    function updateBoxPreview(box_id) {
        let box_data = null;

        jQuery.each(box_products, function (index, item) {
            if (item.id === parseInt(box_id)) {
                box_data = item;
                return false; // Break array
            }
        });

        // Update preview
        if (box_data != null) {
            let title = $("<div/>").html(box_data.title).text();

            $('.js-gift-box-title').html(title);
            $('.js-gift-box-price').text(box_data.price_formatted);
            $('.js-gift-box-img').attr('src', box_data.image);

            $giftBoxInput.data('price', box_data.price);
        }
    }

    // Remove all products
    $('.js-clear-product-selections').click(function (e) {
        e.preventDefault();
        remove_all_products();
    });

    // Remove single product
    $(document).on('click', '.js-remove-product-preview', function (e) {
        e.preventDefault();

        let prod_id = $(this).data('id');
        remove_product(prod_id);
    });

    // Extras - Simple
    $(document).on('click', '.js-bab-add-packaging', function (e) {
        e.preventDefault();
        let extraId = $(this).data('id');
        packaging_ids[0] = extraId;

        let $toUnset = $('.js-bab-add-packaging.active');

        updateExtraIdInput(packaging_ids, $packagingInput);

        unsetActiveBtn($toUnset);
        setActiveBtn($(this));
        updateDropdownPreview('#packaging-dropdown-dropdown', $packagingInput, packaging_products, 1);
        update_prices();
    });

    $(document).on('click', '.js-bab-add-card', function (e) {
        e.preventDefault();
        let extraId = $(this).data('id');
        card_ids[0] = extraId;

        let $toUnset = $('.js-bab-add-card.active');

        updateExtraIdInput(card_ids, $cardInput);

        unsetActiveBtn($toUnset);
        setActiveBtn($(this));
        updateDropdownPreview('#cards-dropdown-dropdown', $cardInput, card_products, 1);
        update_prices();
    });

    // Extras Tabs
    $(document).on('click', '.js-extra-tab-trigger', function (e) {
        e.preventDefault();

        // Show Listing
        let target = $(this).data('target');
        $(target).show();
        $(target).siblings().hide();
        // Set active button
        let otherBtns = $(this).siblings();
        $(this).addClass('active');
        otherBtns.removeClass('active');
        // Trigger Dropdown
        let relatedDropdown = $(this).data('related-dropdown');
        $(relatedDropdown).slideDown();
        otherBtns.each(function () {
            relatedDropdown = $(this).data('related-dropdown');
            $(relatedDropdown).removeClass('active');
            $(relatedDropdown).slideUp();
        });
    });

    $disableMessageCheckbox.change(function(e) {
        // Disable the checkout button if the checkbox is checked
        if($(this).is(':checked')) {
            $nextPageBtn.prop('disabled', true);
        } else {
            $nextPageBtn.prop('disabled', false);
        }
    });

    $cardMessageInput.on('input', function() {
        validateCardMessage();
    });

    function add_product(product_id) {
        product_ids.push(product_id);
        updateProductIdInput();
        updateProductPreviews();
        triggerToggleAnimation();
    }

    function triggerToggleAnimation() {
        let $trayToggle = $('.js-bab-tray-toggle');
        $trayToggle.addClass('added');
        setTimeout(function () {
            $trayToggle.removeClass('added');
        }, 3000);
    }

    function remove_product(product_id) {
        let findInArr = product_ids.indexOf(product_id);
        if (findInArr !== -1) {
            product_ids.splice(findInArr, 1);
        }
        updateProductIdInput();
        updateProductPreviews();
    }

    function remove_all_products() {
        product_ids = [];
        updateProductIdInput();
        updateProductPreviews();

        // Reset quantity inputs
        let $quantityInputs = $('input[name="quantity"]');
        if ($quantityInputs.length > 0) {
            $quantityInputs.each(function () {
                $(this).val(0);
            });
        }
    }

    function remove_extra_products(limit) {
        if (product_ids.length > limit) {
            product_ids.length = limit;
            updateProductIdInput();
            // Reset quantity inputs
            let $quantityInputs = $('input[name="quantity"]');
            if ($quantityInputs.length > 0) {
                $quantityInputs.each(function () {
                    let prod_id_to_search = $(this).data('id');

                    if (jQuery.inArray(prod_id_to_search, product_ids) !== -1) {
                        let quantity = $.grep(product_ids, function (elem) {
                            return elem === prod_id_to_search;
                        }).length;

                        $(this).val(quantity);
                    } else {
                        $(this).val(0);
                    }
                });
            }
        }

        updateProductPreviews();
    }

    function updateProductIdInput() {
        $product_ids_input.val(product_ids.join(','));
    }

    function updateExtraIdInput(values, $input) {
        $input.val(values.join(','));
    }

    function updateProductPreviews() {
        let $tileHolder = $('.active .js-box-switcher-tiles');
        let html = '';

        for (var i = 0; i < product_limit; i++) {
            if (typeof product_ids[i] === 'undefined') {
                html += '<div class="box-switcher__tiles__column js-product-preview-col"><div class="box-switcher__tiles__tile"><span class="box-switcher__tiles__tile__placeholder">' + (i + 1) + '</span></div></div>';
            } else {
                jQuery.each(collection_products, function (index, item) {
                    if (item.id === product_ids[i]) {
                        html += '<div class="box-switcher__tiles__column js-product-preview-col"><div class="box-switcher__tiles__tile"><div class="box-switcher__tiles__tile__product-info" style="background-image: url(' + item.image + ');"><div class="box-switcher__tiles__tile__product-info__close"><button type="button" class="box-switcher__tiles__tile__product-info__close__btn js-remove-product-preview" data-id="' + item.id + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="w-100" fill="currentColor"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></button></div><span class="box-switcher__tiles__tile__product-info__title"><span>' + item.title + '</span></span></div></div></div>';
                        return false; // Break array
                    }
                });
            }
        }

        $tileHolder.find('.js-product-preview-col').remove();
        $tileHolder.prepend(html);

        // Step 1 Next Btn
        setStep1NextBtn();

        // Update Quantity Inputs
        updateMaxQuantityOnInputs();
    }

    function setStep1NextBtn() {
        if (product_ids.length >= product_limit) {
            $nextPageBtn.removeAttr("disabled");

            let btnText = '<span>Continue</span><span class="box-button-icon__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-100" fill="currentColor"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"/></svg></span>';
            $nextPageBtn.html(btnText);
        } else {
            $nextPageBtn.attr("disabled", true);

            let btnText = '<span>Add <span class="js-limit-counter">' + product_limit + '</span> to continue</span>';
            $nextPageBtn.html(btnText);
        }
    }

    function updateMaxQuantityOnInputs() {
        let no_products_left = product_limit - product_ids.length;

        let $quantityInputs = $('input[name="quantity"]');
        if ($quantityInputs.length > 0) {
            $quantityInputs.each(function () {
                if ($(this).data('type') == 'slice') {
                    $(this).attr('max', no_products_left + $(this).val());
                }
            });
        }
    }

    function goToPage(page) {
        let $step1Info = $('#step-1-info');
        let $step2Info = $('#step-2-info');
        let $step3Info = $('#step-3-info');

        // Hide show page
        if (page == 1) {
            $page1.addClass('active');
            $page2.removeClass('active');
            $page3.removeClass('active');

            $step1Info.show();
            $step2Info.hide();
            $step3Info.hide();

            setStep1NextBtn();
        } else if (page == 2) {
            $page1.removeClass('active');
            $page2.addClass('active');
            $page3.removeClass('active');

            $step1Info.hide();
            $step2Info.show();
            $step3Info.hide();

            let btnText = '<span>Continue</span><span class="box-button-icon__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-100" fill="currentColor"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"/></svg></span>';
            $nextPageBtn.html(btnText);

        } else if (page == 3) {
            $page1.removeClass('active');
            $page2.removeClass('active');
            $page3.addClass('active');

            $step1Info.hide();
            $step2Info.hide();
            $step3Info.show();

            let btnText = '<span>Continue to cart</span><span class="box-button-icon__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-100" fill="currentColor"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"/></svg></span>';
            $nextPageBtn.html(btnText);
        }

        // Update progress bar
        let $progressBarItems = $('.js-progress-bar-item');
        jQuery.each($progressBarItems, function (index, item) {
            let progressBtn = $(this).find('button');

            if (index + 1 < page) {
                $(this).addClass('complete');
                $(this).removeClass('active');
                $(progressBtn).removeAttr("disabled");
            } else if (index + 1 == page) {
                $(this).addClass('active');
                $(this).removeClass('complete');
                $(progressBtn).attr("disabled", true);
            } else {
                $(this).removeClass('active');
                $(this).removeClass('complete');
                $(progressBtn).attr("disabled", true);
            }
        });

        // Update Next Page Btn
        $nextPageBtn.data('next-page', page + 1);
    }

    function unsetActiveBtn($btn) {
        $btn.removeClass('active');
        $btn.find('.js-btn-text').text('Add');
        $btn.find('.js-check-icon').hide();
        $btn.find('.js-plus-icon').show();
    }

    function setActiveBtn($btn) {
        $btn.addClass('active');
        $btn.find('.js-btn-text').text('Added');
        $btn.find('.js-check-icon').show();
        $btn.find('.js-plus-icon').hide();
    }

    function updateDropdownPreview(dropdownId, $input, data_arr, limit) {
        let values = $input.val().split(',');

        let totalPrice = 0;
        let togglePreviews = $(dropdownId + ' .js-dropdown-preview-img');
        let revealPreviews = $(dropdownId + ' .js-dropdown-reveal-preview');

        for (var i = 0; i < limit; i++) {
            let currTogglePreview = togglePreviews[i];
            let revealPreview = revealPreviews[i];

            if (typeof values[i] === 'undefined' || values[i] === "") {
                $(currTogglePreview).css('background-image', '');
                $(revealPreview).css('background-image', '');
                $(revealPreview).hide();
            } else {
                jQuery.each(data_arr, function (index, item) {
                    if (item.id === parseInt(values[i])) {
                        totalPrice += parseFloat(item.price);

                        $(currTogglePreview).css('background-image', 'url(' + item.image + ')');
                        $(revealPreview).css('background-image', 'url(' + item.image + ')');
                        $(revealPreview).show();
                        return false; // Break array
                    }
                });
            }
        }

        $input.data('price', totalPrice);
    }

    function add_gift(product_id) {
        gift_ids.push(product_id);
        updateExtraIdInput(gift_ids, $giftInput);

        updateDropdownPreview('#gifts-dropdown-dropdown', $giftInput, gift_products, 3);
        update_prices();
        triggerToggleAnimation();
    }

    function remove_gift(product_id) {
        let findInArr = gift_ids.indexOf(product_id);
        if (findInArr !== -1) {
            gift_ids.splice(findInArr, 1);
        }
        updateExtraIdInput(gift_ids, $giftInput);

        updateDropdownPreview('#gifts-dropdown-dropdown', $giftInput, gift_products, 3);
        update_prices();
    }

    function add_packaging(product_id) {
        packaging_ids[0] = product_id;
        updateExtraIdInput(packaging_ids, $packagingInput);

        updateDropdownPreview('#packaging-dropdown-dropdown', $packagingInput, packaging_products, 1);
        update_prices();
        triggerToggleAnimation();
    }

    function remove_packaging() {
        packaging_ids = [];
        $packagingInput.val('');

        updateDropdownPreview('#packaging-dropdown-dropdown', $packagingInput, packaging_products, 1);
        update_prices();
    }

    function add_card(product_id) {
        card_ids[0] = product_id;
        updateExtraIdInput(card_ids, $cardInput);

        updateDropdownPreview('#cards-dropdown-dropdown', $cardInput, card_products, 1);
        update_prices();
        triggerToggleAnimation();

        // Validate the card message
        validateCardMessage();
    }

    function remove_card() {
        card_ids = [];
        updateExtraIdInput(card_ids, $cardInput);

        updateDropdownPreview('#cards-dropdown-dropdown', $cardInput, card_products, 1);
        update_prices();

        // Validate the card message
        validateCardMessage();
    }

    function validateCardMessage() {
        if($cardInput.val() != '' && $cardInput.val() != null) {
            $disableMessageCheckbox.prop('checked', false).change();
        } else if($cardMessageInput.val() == '') {
            $disableMessageCheckbox.prop('checked', false).change();
        } else {
            $disableMessageCheckbox.prop('checked', true).change();
        }

        hideShowCardMessageError();
    }

    function hideShowCardMessageError() {
        let $cardMsgError = $('#cardMessageError');
        console.log($cardMsgError);

        if($disableMessageCheckbox.is(':checked')) {
            $cardMsgError.show();
        } else {
            $cardMsgError.hide();
        }
    }

    function update_prices() {
        let $priceGroup = $('.js-price-group');
        $priceGroup.each(function () {
            let total = 0;
            let $priceListItems = $(this).find('.js-price-item');
            let $total = $(this).find('.js-total-price');

            $priceListItems.each(function () {
                let price = parseFloat($($(this).data('related-input')).data('price')/100);

                if (price == "" || price == null) {
                    price = 0;
                }

                total += parseFloat(price);

                $(this).html('£' + format_price(price));

                if (price == 0) {
                    $(this).parent().addClass('bab-collapse');
                } else {
                    $(this).parent().removeClass('bab-collapse');
                }
            });
            $total.html('£' + format_price(total));
        });
    }

    function format_price(number) {
        return parseFloat(number).toFixed(2);
    }

    function add_box_to_cart() {
        let properties = [];

        // Slice Product
        let currSliceProduct = sliceProductSlice5;
        if (product_limit == 3) {
            currSliceProduct = sliceProductSlice3;
        }

        properties.push({
            variant: "gid://shopify/ProductVariant/" + currSliceProduct.val(),
            variant_id: currSliceProduct.val(),
            variant_price: currSliceProduct.data('price'),
            product_id: currSliceProduct.data('product-id'),
            product_title: currSliceProduct.data('product-title'),
            variant_title: currSliceProduct.data('variant-title'),
            qty: 1,
            note: ""
        });

        // Get the slices
        let slices = $product_ids_input.val().split(",");
        let unique_slices = unique_list(slices);
       

        jQuery.each(unique_slices, function (index, item) {

            let quantity = arr_counter(slices, item);
            let productInfo = null;

            jQuery.each(collection_products, function (index, currprod) {
                if (currprod.id == item) {
                    productInfo = currprod;
                }
            });

            let currSlice = {
                variant: "gid://shopify/ProductVariant/" + item,
                variant_id: item,
                variant_price: 0,
                product_id: productInfo.product_id,
                product_title: productInfo.title,
                variant_title: "Default Title",
                qty: quantity,
                note: ""
            }

            properties.push(currSlice);
        });

        // Gift Box
        properties.push({
            variant: "gid://shopify/ProductVariant/" + $giftBoxInput.val(),
            variant_id: $giftBoxInput.val(),
            variant_price: $giftBoxInput.data('price'),
            product_id: $giftBoxInput.data('product-id'),
            product_title: $giftBoxInput.data('product-title'),
            variant_title: $giftBoxInput.data('variant-title'),
            qty: 1,
            note: ""
        });
        
        // Gifts
        if ($giftInput.val() != "" && $giftInput.val() != null) {
            let gifts = $giftInput.val().split(",");
            let unique_gifts = unique_list(gifts);

            jQuery.each(unique_gifts, function (index, item) {
                let quantity = arr_counter(gifts, item);
                let giftprod = null;

                jQuery.each(gift_products, function (index, giftitem) {
                    if (giftitem.id === parseInt(item)) {
                        giftprod = giftitem;
                        return false; // Break array
                    }
                });

                let currExtra = {
                    variant: "gid://shopify/ProductVariant/" + item,
                    variant_id: item,
                    variant_price: giftprod.price,
                    product_id: giftprod.product_id,
                    product_title: giftprod.title,
                    variant_title: "Default Title",
                    qty: quantity,
                    note: ""
                }

                properties.push(currExtra);
            });
        }

        // Packaging
        if ($packagingInput.val() != "" && $packagingInput.val() != null) {
            let selectedProd = null;

            jQuery.each(packaging_products, function (index, packagingItem) {
                if (packagingItem.id === parseInt($packagingInput.val())) {
                    selectedProd = packagingItem;
                    return false;
                }
            });

            properties.push({
                variant: "gid://shopify/ProductVariant/" + $packagingInput.val(),
                variant_id: $packagingInput.val(),
                variant_price: selectedProd.price,
                product_id: selectedProd.product_id,
                product_title: selectedProd.title,
                variant_title: "Default Title",
                qty: 1,
                note: ""
            });
        }

        // Cards
        if ($cardInput.val() != "" && $cardInput.val() != null) {
            let selectedProd = null;

            jQuery.each(card_products, function (index, cardItem) {
                if (cardItem.id === parseInt($cardInput.val())) {
                    selectedProd = cardItem;
                    return false;
                }
            });

            properties.push({
                variant: "gid://shopify/ProductVariant/" + $cardInput.val(),
                variant_id: $cardInput.val(),
                variant_price: selectedProd.price,
                product_id: selectedProd.product_id,
                product_title: selectedProd.title,
                variant_title: "Default Title",
                qty: 1,
                note: $('#card-message').val()
            });
        }

        // Let's get this into the app
        // - Build the data to send
        let
            properties_bundle = [],
            bundleIds = [],
            bundlePrices = [],
            bundleQuantities = [],
            bundleTitles = [];

        properties.forEach((element) => {
            let
                bundleTitle,
                variantId = element.variant_id,
                variantPrice = parseFloat(element.variant_price),
                productId = element.product_id,
                productTitle = element.product_title,
                variantTitle = element.variant_title,
                variantQty = parseInt(element.qty),
                currentVariant = {
                    id: "gid://shopify/ProductVariant/" + variantId,
                    qty: variantQty,
                    price: (variantPrice / 100),
                    note: element.note
                };

            if (variantTitle !== 'Default Title') {
                bundleTitle = productTitle + ' - ' + variantTitle + ' - Quantity: ' + variantQty
            } else {
                bundleTitle = productTitle + ' - Quantity: ' + variantQty
            }

            if (variantQty > 0) {
                properties_bundle.push(currentVariant);
                bundleIds.push(variantId);
                bundlePrices.push(variantPrice);
                bundleQuantities.push(variantQty);
                bundleTitles.push(bundleTitle);
            }
        });

        let bundleParentVariantId = $bundleTopLevelProductInput.val();

        let formData = {
            items: [
                {
                    id: bundleParentVariantId,
                    quantity: 1,
                    properties: {
                        _kayo_bundle: JSON.stringify(properties_bundle),
                        _kayo_bundle_ids: bundleIds,
                        _kayo_bundle_prices: bundlePrices,
                        _kayo_bundle_quantities: bundleQuantities,
                        _kayo_bundle_titles: bundleTitles,
                        _gs_bundle_contents: bundleTitles
                    },
                },
            ],
        };
        // Now let's add it to the cart
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then(response => {
                /*
                let featuredImage = response.items[0].featured_image;
                let productTitle = response.items[0].product_title;
                let itemCartQty = response.items[0].quantity;
                let cartNotificationProductContainer = document.getElementById('cart-notification-product');
                let notification = document.getElementById('cart-notification');
                let cartQtyLabel = document.getElementsByClassName("quantity-cart")[0];

                cartNotificationProductContainer.innerHTML = `<div class="cart-notification-product__image global-media-settings"><img src="` + featuredImage.url + `" alt="` + featuredImage.alt + `" width="70" height="70"></div>`;
                cartNotificationProductContainer.innerHTML += `<div><h3 class="cart-notification-product__name h4">` + productTitle + `</h3></div>`
                cartQtyLabel.innerHTML = itemCartQty;

                notification.classList.add('animate', 'active');
                */
            })
            .catch((error) => {
                console.error('Error:', error);
            });


    }

    function unique_list(list) {
        var result = [];
        jQuery.each(list, function (i, e) {
            if ($.inArray(e, result) == -1) result.push(e);
        });
        return result;
    }

    function arr_counter(array, to_count) {
        let counter = 0;

        for (var i = 0; i < array.length; i++) {
            if (array[i] == to_count) {
                counter++;
            }
        }

        return counter;
    }
});